import { Tooltip } from '@ds';
import { MdOutlineWifiTethering } from 'react-icons/md';
import { CaseUserGroup } from '@/api/apis/case';
import { externalIconGroups } from './config';

type SharePrimaryIconProps = {
  isPrimary?: boolean;
  groupKey: CaseUserGroup;
};

export const SharePrimaryIcon = ({ isPrimary, groupKey }: SharePrimaryIconProps) => {
  return isPrimary && externalIconGroups.includes(groupKey) ? (
    <Tooltip content="Resource shared externally">
      <div>
        <MdOutlineWifiTethering />
      </div>
    </Tooltip>
  ) : null;
};
